<script lang="ts">
  import { faPlus } from '@fortawesome/free-solid-svg-icons';
  import { tick } from 'svelte';
  import type { EditorState } from '../editor-state.svelte';
  import Icon from './Icon.svelte';
  import type { PanelSection } from './panel-section';

  const { editor, section, id }: { editor: EditorState; section: PanelSection; id: string } =
    $props();

  // The new item is the list's last; its name is selected, ready to type over.
  async function add(button: HTMLButtonElement, run: (editor: EditorState) => void) {
    const region = button.closest('section');
    run(editor);
    await tick();
    region?.querySelector<HTMLInputElement>('li:last-child input.name')?.select();
  }
</script>

<div class="heading">
  <h2 {id} class="label">{section.label}</h2>
  {#if section.add}
    {@const { label, title, run, disabled } = section.add}
    <button
      type="button"
      class="add"
      {title}
      disabled={disabled(editor)}
      onclick={(event) => add(event.currentTarget, run)}
    >
      <Icon icon={faPlus} />
      {label}
    </button>
  {/if}
</div>

<style>
  /* As tall with a button as without, so switching sections never moves the body. */
  .heading {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-2);
    min-height: 1.625rem;
    margin: 0 0 var(--space-2);
  }

  h2 {
    margin: 0;
    color: var(--color-text-muted);
    font: inherit;
  }

  .label {
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  .add {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 8px;
    border: 1px solid var(--color-border);
    border-radius: 6px;
    background: none;
    color: var(--color-text-muted);
    font: inherit;
    font-size: 0.75rem;
    cursor: pointer;
  }

  .add:hover {
    color: var(--color-text);
  }

  .add:disabled {
    opacity: 0.5;
    cursor: default;
  }
</style>
